<template>
    <div class="container">
        <h3 class="my-4">Listado de Productos</h3>

        <div class="row">
            <div class="col-md-4 col-sm-12 mb-3">
                <div>
                    <form @submit.prevent="buscarProducto(texto)">
                        <input type="text" placeholder="Buscar..." class="form-control" v-model="texto" v-on:keyup="buscarProducto(texto)">
                    </form>
                </div>
            </div>
            <div class="col-md-8 col-sm-12 mb-3">
                <div class="float-right">
                    <routerLink class="btn btn-info btn-sm" :to="{name: 'productoCrear'}">Agregar</routerLink>
                </div>
            </div>
            <div class="col-lg-12">
                <table class="table" id="my-table" :per-page="perPage" :current-page="currentPage">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">Precio</th>
                            <th scope="col">Estado</th>
                            <th scope="col">F. Registro</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(producto, index) of productoFiltrado" :key="producto.id">
                            <th scope="row">{{ index + 1 }}</th>
                            <td>{{ producto.NOM_PRODUCTO }}</td>
                            <td>{{ producto.IMP_UNITARIO }}</td>
                            <td>{{ producto.IND_ACTIVO ? 'Activo' : 'Inactivo' }}</td>
                            <td>{{ producto.FEC_CREACION }}</td>
                            <td>
                                <button class="btn btn-danger btn-sm ml-2 float-right" @click="eliminarProducto(producto.id)">
                                    Eliminar
                                </button>
                                <routerLink class="btn btn-warning btn-sm float-right"
                                    :to="{name: 'productoEditar', params: {id: producto.id}}">
                                    Editar
                                </routerLink>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!--<b-table
                    id="my-table"
                    :items="productos"
                    :per-page="perPage"
                    :current-page="currentPage"
                    small
                ></b-table>-->

                <div class="mt-3">
                    <b-pagination aria-controls="my-table" align="center"
                        v-model="currentPage" 
                        :total-rows="rows" 
                        :per-page="perPage">
                    </b-pagination>
                </div>

                <p class="mt-3">Página Actual: {{ currentPage }}</p>

                <div v-if="carga">
                    <!--<b-spinner label="Cargando..." variant="info"></b-spinner>-->
                    <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner" variant="info"></b-spinner>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
    name: 'Listar',
    methods: {
        ...mapActions(['listarProductos', 'eliminarProducto', 'buscarProducto'])
    },
    created() {
        this.listarProductos();
    },
    computed: {
        ...mapState(['productos', 'carga']),
        ...mapGetters(['productoFiltrado']),
        rows() {
            return this.productos.length;
        }
    },
    data() {
        return {
            perPage: 3,
            currentPage: 1,
            texto: ''
        }
    }
}
</script>